import { TERM_HIERARCHY_DISPLAY_SEPARATOR, TRUNCATE_VALUE } from 'config/constants';

var generateTruncatedSections = function generateTruncatedSections(allSections) {
  var sectionsArray = allSections.split(TERM_HIERARCHY_DISPLAY_SEPARATOR);

  if (sectionsArray.length <= 2) {
    return allSections;
  }

  return [sectionsArray[0], TRUNCATE_VALUE, sectionsArray[sectionsArray.length - 1]].join(TERM_HIERARCHY_DISPLAY_SEPARATOR);
};

export default generateTruncatedSections;